import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { HelperService } from './helper.service';
import { UserIndustries } from '../../shared/models/user-industries.model';
import { API_ENDPOINTS } from '../../shared/constants/api-endpoints';

@Injectable({
  providedIn: 'root',
})
export class UserPermissionService extends BaseService {
  public constructor(
    public override readonly http: HttpClient,
    private readonly helperService: HelperService,
  ) {
    super(http);
  }
  public getMyIndustries(): Observable<ReadonlyArray<UserIndustries>> {
    let url = this.helperService.prepareAPIURLBasedOnRegions();
    url = `${url}${API_ENDPOINTS.authorization}/me/industries`;
    return this.baseGet<ReadonlyArray<UserIndustries>>(url);
  }
}
